export default [
  {
    text: 'Кабинетная',
    value: 'cabinet',
  },
  {
    text: 'Открытая',
    value: 'openSpace',
  },
  {
    text: 'Коридорная',
    value: 'corridorplan',
  },
  {
    text: 'Смешанная',
    value: 'mixed',
  },
];
